import dayjs, { Dayjs } from 'dayjs'

import { FormField } from '@cloudscape-design/components'

// @ts-ignore
import { DateTimePicker } from '@mui/x-date-pickers'
// import { MobileDateTimePicker } from '@mui/x-date-pickers'

export type DateInputProps = {
    label: string,
    value: string, 
    onChange?: (value: string) => void, 
    validate?: (value: string, label: string) => boolean,
    readOnly: boolean, 
    [rest: string]: any,
}

export default (props: DateInputProps) => {

    dayjs.extend(require('dayjs/plugin/localizedFormat'))

    const valid = props.readOnly ? true : props.validate ? props.validate(props.value, props.label) : true

    let day = dayjs(props.value)

    // let day = dayjs(props.value, 'YYYY-MM-DD hh:mm a')
    if (!day?.isValid()) day = dayjs()

    const setDay = (date: Dayjs | null) => {
        // setValue(date)
        props.onChange && props.onChange(date?.format("YYYY-MM-DD HH:mm") || '')
    }
    return (
        <FormField label={props.label} info={!props.validate ? 'Optional' : ''} >
            <DateTimePicker readOnly={props.readOnly} valid={valid}
            // <MobileDateTimePicker readOnly={props.readOnly} valid={valid}
                value={ day }
                onChange={setDay}
                sx={{"& .MuiOutlinedInput-root": {borderRadius: 2, borderColor: 'black'}, "& .MuiOutlinedInput-input": { padding: (5/8), pl: 1 } }}
                {...props.rest}
            />
        </FormField>
    )
}